var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { cloneElement } from 'react';
import toArray from 'rc-util/lib/Children/toArray';
import classNames from 'classnames';
import Step from './step';
export default class Steps extends React.Component {
    constructor() {
        super(...arguments);
        this.onStepClick = (next) => {
            const { onChange, current } = this.props;
            if (onChange && current !== next) {
                onChange(next);
            }
        };
    }
    render() {
        const _a = this.props, { prefixCls, style = {}, className, children, direction, type, labelPlacement, iconPrefix, status, size, current, progressDot, stepIcon, initial, icons, onChange } = _a, restProps = __rest(_a, ["prefixCls", "style", "className", "children", "direction", "type", "labelPlacement", "iconPrefix", "status", "size", "current", "progressDot", "stepIcon", "initial", "icons", "onChange"]);
        const isNav = type === 'navigation';
        const adjustedLabelPlacement = progressDot ? 'vertical' : labelPlacement;
        const classString = classNames(prefixCls, `${prefixCls}-${direction}`, className, {
            [`${prefixCls}-${size}`]: size,
            [`${prefixCls}-label-${adjustedLabelPlacement}`]: direction === 'horizontal',
            [`${prefixCls}-dot`]: !!progressDot,
            [`${prefixCls}-navigation`]: isNav
        });
        return (<div className={classString} style={style} {...restProps}>
                {toArray(children).map((child, index) => {
                const stepNumber = initial + index;
                const childProps = Object.assign({ stepNumber: `${stepNumber + 1}`, stepIndex: stepNumber, key: stepNumber, prefixCls,
                    iconPrefix, wrapperStyle: style, progressDot,
                    stepIcon,
                    icons, onStepClick: onChange && this.onStepClick }, child.props);
                // fix tail color
                if (status === 'error' && index === current - 1) {
                    childProps.className = `${prefixCls}-next-error`;
                }
                if (!child.props.status) {
                    if (stepNumber === current) {
                        childProps.status = status;
                    }
                    else if (stepNumber < current) {
                        childProps.status = 'finish';
                    }
                    else {
                        childProps.status = 'wait';
                    }
                }
                childProps.active = stepNumber === current;
                return cloneElement(child, childProps);
            })}
            </div>);
    }
}
Steps.Step = Step;
Steps.defaultProps = {
    type: 'default',
    prefixCls: 'rc-steps',
    iconPrefix: 'rc',
    direction: 'horizontal',
    labelPlacement: 'horizontal',
    initial: 0,
    current: 0,
    status: 'process',
    size: '',
    progressDot: false
};
